export default "__VITE_PUBLIC_ASSET__659a6496__"